import { differenceInCalendarDays, isValid, parseISO } from 'date-fns';

// Mirrors the API rule (ConsolidatedStudentReport.parsePeriod).
export const MAX_REPORT_DAYS = 366;

export const validateReportPeriod = (dateStart, dateEnd) => {
  const start = parseISO(dateStart || '');
  const end = parseISO(dateEnd || '');

  if (!isValid(start) || !isValid(end)) {
    return 'Selecione a data inicial e a data final.';
  }

  if (end < start) {
    return 'A data final deve ser igual ou posterior à data inicial.';
  }

  if (differenceInCalendarDays(end, start) + 1 > MAX_REPORT_DAYS) {
    return 'Período inválido. Selecione até 12 meses.';
  }

  return null;
};

export default validateReportPeriod;
